import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (payload) => api.post("/leads", payload);
export const adminLogin = (password) => api.post("/admin/login", { password });
export const fetchLeads = (token) =>
    api.get("/leads", { headers: { "X-Admin-Token": token } });
export const fetchStats = (token) =>
    api.get("/leads/stats", { headers: { "X-Admin-Token": token } });
